<template>
  <CardSection :loading="isSavableStateLoading" :error="majorError">
    <template #header>
      {{ createNew ? 'New' : 'Edit' }} TxC Config {{ selectedTxcConfig ? `- ${selectedTxcConfig.code}` : '' }}
    </template>
    <template #body>
      <SubSection :sub-section-heading="createNew ? '' : 'TxC Organ Configuration'" :sub-section-nav="subSectionNav">              
        <template #body>
          <template v-if="!isSavableStateLoading && selectedTxcConfig">

            <VeeForm @submit="onSubmit" ref="addTxcConfigForm">
              <div class="row">
                <MultiSelectInput v-model="selectedTxcConfig.id"
                  name="transplantCenter"
                  label="Transplant Center"
                  :options="txcStore.transplantCenters"
                  label-key="code"
                  value-key="id"
                  rules="required"
                  :disabled="true"
                  col-style="form-group-standard-column" />
              </div>

              <div class="row">
                <MultiSelectInput v-model="selectedOrganGroup"
                  name="organ"
                  label="Organ"
                  :options="organGroupOptions"
                  label-key="name"
                  value-key="id"
                  rules="required"
                  col-style="form-group-standard-column" />
              </div>
              <div class="row">
                <div class="col-lg-4 col-md-4">
                  <div class="form-check form-check-inline">
                    <input id="fdCalculationAutoApproval" 
                      v-model="fdCalculationAutoApproval"
                      class="form-check-input" 
                      type="checkbox"
                      aria-labelledby="fdCalculationAutoApproval">
                    <label class="form-check-label" for="fdCalculationAutoApproval">
                      FD Calculation Auto Approval
                    </label>
                  </div>
                </div>
              </div>
            
              <ActionToolbar :component-state="currentState" 
                :error-message="formError" 
                :success-message="successMessage" 
                :primary-button-text="createNew ? 'Create Txc Config' : 'Add Organ Config'"
                :secondary-button-text="createNew ? 'Cancel' : 'Close'"
                :tertiary-enabled="false"
                @secondary-click="cancel"
              />
            </VeeForm>

            <hr>
            <TransplantCenterOrganConfigTable 
              :transplant_center_configurations="selectedTxcConfig ? selectedTxcConfig.transplant_center_configurations : []"
              :loading="isSavableStateLoading || isSavableStateProcessing" />
        
          </template>
        </template>
      </SubSection>
    </template>
  </CardSection>
</template>
<script>
import CardSection from "@/src/components/shared/CardSection.vue";
import SubSection from "@/src/components/shared/SubSection.vue";
import ActionToolbar from "@/src/components/shared/ActionToolbar.vue";
import MultiSelectInput from "@/src/components/shared/FormComponents/MultiSelectInput.vue";
import '@/src/vee-validate.js';
import { Form as VeeForm } from 'vee-validate';
import { useTxcStore } from '@/src/stores/transplant_centers';
import {transplantCenterSubSectionNavMixin} from "@/src/components/admin-area/transplant_centers/transplantCenterSubSectionNavMixin";
import { savableStateMixin } from "@/src/mixins/savableStateMixin";
import PortalTable from "@/src/components/shared/PortalTable.vue";
import Column from 'primevue/column';
import { FilterMatchMode } from '@primevue/core/api';
import TransplantCenterOrganConfigTable from "./_transplantCenterOrganConfigTable.vue";

export default {
  components: {
    CardSection,
    SubSection,
    MultiSelectInput,
    VeeForm,
    ActionToolbar,
    PortalTable,
    Column,
    TransplantCenterOrganConfigTable
  },
  mixins: [ savableStateMixin , transplantCenterSubSectionNavMixin ],
  setup() {
    const txcStore = useTxcStore();
    return { txcStore };
  },
  data() {
    return {
      successMessage: null,
      selectedTxcConfig: null,
      selectedOrganGroup: null,
      fdCalculationAutoApproval: null,
      filterValues: {
        "organ_group_id" : { value: null, matchMode: FilterMatchMode.IN },
      }
    }
  },
  computed: {
    createNew() {
      return this.$route.params.id ? false : true;
    },
    organGroupOptions() {
      if(!this.txcStore.organGroups)  return null;

      if(!this.selectedTxcConfig && !this.selectedTxcConfig.transplant_center_configurations) {
        return this.txcStore.organGroups;
      } else {
        return this.txcStore.organGroups.filter(item => {
          return !this.selectedTxcConfig.transplant_center_configurations
            .some(tcc => tcc.organ_group_id === item.id);
        });
      }
    },
  },
  async mounted() {
    try {
      this.setSavableStateLoading();
      if(!this.createNew) {
        this.selectedTxcConfig = await this.txcStore.loadTransplantCentre(this.$route.params.id);
      }
      else{
        this.selectedTxcConfig =  {} 
      }
      await this.txcStore.loadAllOrganGroups();
      await this.txcStore.loadTransplantCentres();
      this.setSavableStateIdle();
    } catch(error) {
      this.handleMajorError(error);
    }
  },
  methods: {
    async onSubmit() {
      try {
        this.setSavableStateProcessing();
       
        const payload = {
          transplant_center_id: this.selectedTxcConfig.id,
          organ_group_id: this.selectedOrganGroup,
          config: {
            fd_calculation_auto_approval: this.fdCalculationAutoApproval
          }
        }
       
        const response = await this.txcStore.createTxcConfigurations(payload);
        this.successMessage = 'Successfully created TxC config!'
        this.clear();
        this.selectedTxcConfig = await this.txcStore.loadTransplantCentre(this.$route.params.id || response.transplant_center_id);
        if (this.createNew) {
          this.$router.push({ name: 'admin_transplant_centers_edit', params: { id: response.transplant_center_id }});
        }
        if(this.$refs.addTxcConfigForm) {
          await this.$refs.addTxcConfigForm.resetForm();
        }
        this.setSavableStateSuccess();
      } catch (error) {
        this.handleFormError(error);
      }
    },
    clear() {
      this.selectedOrganGroup = null;
      this.fdCalculationAutoApproval = null;
    },
    cancel() {
      this.$router.push({ name: 'admin_transplant_centers' });
    }
  }
}
</script>
